import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApiVisa, GlcategorylistService, GlCategoryListContainerModel } from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// import "rxjs-compat/add/operator/map";

@Component({
  selector: 'app-select-glcategory-drop-down',
  templateUrl: './select-glcategory-drop-down.component.html',
  styleUrls: ['./select-glcategory-drop-down.component.scss']
})

export class SelectGLCategryDropDownComponent implements OnInit, OnDestroy {

  @Input() apiVisa: ApiVisa;
  @Input() glCategory = new FormControl();
  @Input() required: boolean;

  @Output() glCategoryChange = new EventEmitter<FormControl>();
  @Output() glCategorySelected = new EventEmitter<GlCategoryListContainerModel>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<GlCategoryListContainerModel[]> = new ReplaySubject<GlCategoryListContainerModel[]>(1);
  glCategoryList: GlCategoryListContainerModel[] = [];
  selectedGLCategory: GlCategoryListContainerModel;
  filteredglCategory: any = [];

  protected _onDestroy = new Subject<void>();

  constructor(
    private glCategoryService: GlcategorylistService
  ) {
  }

  ngOnInit() {
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterglCategory();
      });

    this.getGLCategory();
  }

  getGLCategory() {
    this.glCategoryService.get(this.apiVisa).subscribe((x: any) => {
      x.data.forEach((data) => {
        this.filteredglCategory.push(data);
        this.glCategoryList.push(data);
      });

      // sorting
      const sorted = this.glCategoryList.sort((a, b) => (a['bl_fi_mst_gl_category_list_hdr'].code < b['bl_fi_mst_gl_category_list_hdr'].code ? -1 : 1));

      this.filteredOptions$.next(sorted.slice());
    });
  }

  filterglCategory() {
    if (!this.filteredglCategory) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.filteredglCategory.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter
    this.filteredOptions$.next(
      this.glCategoryList.filter((option) =>
        (option.bl_fi_mst_gl_category_list_hdr.code ?
          option.bl_fi_mst_gl_category_list_hdr.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.bl_fi_mst_gl_category_list_hdr.name ?
          option.bl_fi_mst_gl_category_list_hdr.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(guid: string) {
    if (guid) {
      console.log(guid)
      this.glCategory.patchValue(guid);
      this.selectedGLCategory = this.glCategoryList.find(fy => fy['bl_fi_mst_gl_category_list_hdr'].guid === guid);
      this.glCategorySelected.emit(this.selectedGLCategory);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
